import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component } from "@angular/core";
import { faExclamationCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Input } from '@angular/core';

@Component({
  selector: 'confirmation-modal',
  templateUrl: "confirmation.modal.html",
  styleUrls: ["./confirmation.modal.scss"]
})
export class ConfirmationModalContent {
  @Input() description: string;
  @Input() successText: string;
  @Input() failureText: string;

  faExclamationCircle = faExclamationCircle;
  faTimes = faTimes;

  constructor(public activeModal: NgbActiveModal) {
  }

  protected doAction(result: boolean) {
    this.activeModal.close(result);
  }
}

/**
 * Параметры диалогового окна
 */
export type ConfirmationModalParameters = {
  modalService: NgbModal,
  question: string,
  positiveText?: string,
  negativeText?: string,
  action?: (boolean) => (void | PromiseLike<void>),
};

/**
 * Отображает диалоговое окно с подтверждением действия пользователя
 * @param modalService Сервис модальных окон
 * @param question Вопрос пользователю
 * @param positiveText Текст кнопки подтверждения действия. По умолчанию: "Да"
 * @param negativeText Текст кнопки отказа от действия. По умолчанию: "Нет"
 * @param action Действие, выполняющееся при подтверждении или отказе пользователем
 */
export const showConfirmation = (
  {
    modalService,
    question,
    positiveText,
    negativeText,
    action,
  }: ConfirmationModalParameters,
) => {
  const emptyAction = () => {
  };
  const defaultSuccessText: string = "Да";
  const defaultFailureText: string = "Нет";

  const modalRef = modalService.open(
    ConfirmationModalContent,
    {
      backdropClass: 'light-white-backdrop',
      centered: true,
      size: 'sm',
      windowClass: 'confirmation-modal very-nice-shadow',
    });
  modalRef.componentInstance.description = question;
  modalRef.componentInstance.successText = positiveText || defaultSuccessText;
  modalRef.componentInstance.failureText = negativeText || defaultFailureText;
  modalRef.result.then(
    action
      ? (result) => action(result)
      : emptyAction,
    action
      ? () => action(false)
      : emptyAction);
}



// WEBPACK FOOTER //
// ./src/app/confirmation-modal/confirmation.modal.ts